export function getClientId() {
    try { 
        if(typeof ga !== 'undefined' && typeof ga.getAll === 'function') {
            var trackerName = ga.getAll()[0].get('name');
            return ga.getByName(trackerName).get('clientId');
        }
    }catch(e){
            return undefined
    };
}

export function pushImpressionView(content) {
  if(content && content.length > 0){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      {
        event:'eec.impressionView',
        ecommerce: {impressions: content}
      });
  }
     
}
export function pushViewItemList(content) {
  if(content && content.length > 0){
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });  
    window.dataLayer.push(
      {
        event: "view_item_list",
        ecommerce: {
          items: content
        }
      });
  };
}
export function pushSelectItem(content) {
  if(content && content.length > 0){
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });  
    window.dataLayer.push(
      {
        event: "select_item",
        ecommerce: {
          item_list_name: 'Search', 
          items: content
        }
      });
  };
}
export function addViewItem(content, currency, total, transaction_id) {
  if(content && content.length > 0){
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });  
    window.dataLayer.push(
      {
        event: "view_item",
        ecommerce: {
          currency: currency,
          value: total,
          transaction_id: transaction_id,
          items: content
        }
      });
  };
}
export function getFbBrowserId() {
  let result = /_fbp=(fb\.1\.\d+\.\d+)/.exec(window.document.cookie);
  if (!(result && result[1])) {
    return null;
  }
  return result[1];
}
function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getFbClickId() {
  let result = /_fbc=(fb\.1\.\d+\.\d+)/.exec(window.document.cookie);
  if (!(result && result[1])) {
    return null;
  }
  return result[1];
}
export function getGoogleClickId() {
  return getParameterByName("gclid");
}
export function pushImpressionClick(payload){
  if(payload && payload.length > 0){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'eec.impressionClick',
      ecommerce: {
        click: {
          actionField: {
            list:''
          },
          products: payload
        }
      }
    });
  }
}
export function pushDetailView(content, currency) {
  if(content && content.length > 0){
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event:'eec.detail',
        ecommerce: {
           currencyCode: currency,
           detail: {
            actionField: {
              list:'Venue'
            },
            products: content
          }
        }
      });
  }
}
export function getMarketingPlatformIds(){
  let fbp, fbc, gclid, msclkid // declaring the variable
  const cookie_val=document.cookie.split(';') // splitting the cookie
  cookie_val.forEach(function (item, index) {  // looping through the cookie to get relevant values
  if(item.match(/_fbc=/g))
  {let match = RegExp(  '_fbc=([^;]*)').exec(window.document.cookie);
    fbc= match[1] }// facebook click id (fbclid)
  else if(item.match(/_fbp=/g))
  {let match = RegExp(  '_fbp=([^;]*)').exec(window.document.cookie);
    fbp= match[1] } // facebook browser id
  else if(item.match(/_gcl_aw=/g))
  {let match = RegExp(   /_gcl_aw=([^;]*)/).exec(window.document.cookie);
    gclid= match[1] }// google ads click id
  else if(item.match(/_uetmsclkid=/g))
  {let match = RegExp(   /_uetmsclkid=([^;]*)/).exec(window.document.cookie);
      msclkid= match[1].replace("_uet", "") }// microsoft click id 
  });
  return {"fb_click_id": fbc, "fb_browser_id": fbp, "ga_ads_click_id": gclid, "ms_click_id": msclkid};
}
function is_gtm_loaded() {
  let gtm_started_event = window.dataLayer.find(element => element['gtm.start']);
  if (!gtm_started_event) {
    return false; // Not even the GTM inline config has executed
  }else if (!gtm_started_event['gtm.uniqueEventId']) {
    return false; // GTM inline config has ran, but main GTM js is not loaded (likely AdBlock, NoScript, URL blocking etc.)
  }
  return true; // GTM is fully loaded and working
}

export function getGASessionInfo(measurement_id) {
  if (!measurement_id) {
    return Promise.resolve(false);
  }
  if(is_gtm_loaded() == false){
    return Promise.resolve(false);
  }
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag('js', new Date());

  gtag('config', measurement_id, {
    send_page_view: false
  });

  const sessionIdPromise = new Promise((resolve, reject) => {
    try {
      gtag('get', measurement_id, 'session_id', resolve);
    } catch (error) {
      console.error('Error in session_id callback:', error);
      reject(error);
    }
  });

  const sessionNumberPromise = new Promise((resolve, reject) => {
    try {
      gtag('get', measurement_id, 'session_number', resolve);
    } catch (error) {
      console.error('Error in session_number callback:', error);
      reject(error);
    }
  });

  const clientIdPromise = new Promise((resolve, reject) => {
    try {
      gtag('get', measurement_id, 'client_id', resolve);
    } catch (error) {
      console.error('Error in client_id callback:', error);
      reject(error);
    }
  });

  return Promise.all([sessionIdPromise, sessionNumberPromise, clientIdPromise])
    .then(([sessionId, sessionNumber, clientId]) => {
      if (sessionId !== undefined && sessionNumber !== undefined && clientId !== undefined) {
        return {
          id: sessionId,
          number: sessionNumber,
          client_id: clientId
        };
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error('Error in getGASessionInfo:', error);
      return false;
    });
}